import * as i0 from '@angular/core';
import { NgModule, Injectable } from '@angular/core';
import * as i1 from '@upr-web-primer/geolocation';
import { GEO_NON_PRIMARY_RESIDENT_VALUE } from '@upr-web-primer/geolocation';
import { isEmpty, filter, find, get, isArray, map, intersection, includes } from 'lodash-es';
class GdsPoiFilterModule {
  static {
    this.ɵfac = function GdsPoiFilterModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsPoiFilterModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: GdsPoiFilterModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsPoiFilterModule, [{
    type: NgModule,
    args: [{}]
  }], null, null);
})();
class GdsPoiFilterService {
  constructor(geo) {
    this.geo = geo;
  }
  filterResults(tiles, selection, promo) {
    if (isEmpty(tiles)) {
      return [];
    }
    if (!selection) {
      return tiles;
    }
    let geo;
    if (promo) {
      const geoLocation = this.geo.getGeoLocationObject();
      geo = geoLocation?.region !== GEO_NON_PRIMARY_RESIDENT_VALUE ? 'fl' : 'ous';
    }
    return filter(tiles, tile => {
      const noMatch = find(selection, (value, property) => !this.matchesProperties(tile, property, value));
      if (noMatch) {
        return false;
      }
      // Toggle Filters
      // TODO: match Tile and Filter so we can remove following block
      // Currently Filter key is 'express_pass' but Tile key is 'ExpressPass'
      if (selection.express_pass && get(tile, 'Meta.ExpressPass[0].Key', '').toLowerCase() !== 'yes') {
        return false;
      }
      // TODO: match Tile and Filter so we can remove following block
      // Currently Filter is 'healthy_option' but Tile is 'ExpressPass'
      if (selection.healthy_options && get(tile, 'Meta.HealthyOptions[0].Key', '').toLowerCase() !== 'yes') {
        return false;
      }
      if (promo) {
        const persona = get(tile, 'Meta.Persona.0.Key');
        if (!persona || persona === 'All') {
          return true;
        }
        if (!geo) {
          return persona === 'ous'; // Show NON FL resident offers by default
        }
        return geo === persona;
      }
      return true;
    });
  }
  getTileKeys(tile, key) {
    const property = get(tile, `Meta.${key}`, null);
    if (isEmpty(property)) {
      return null;
    }
    return isArray(property) ? map(property, 'Key') : get(property, 'Key');
  }
  matchesProperties(tile, property, criteria = null) {
    // Get filter criteria
    const isCriteriaEmpty = isEmpty(criteria);
    const isCriteriaArray = isArray(criteria);
    // TODO: Clean in future
    // CMS Accessibility Keys are different than the rest,
    // have to filter them in a different way
    const tileKey = property === 'accessibility' ? this.getAccessibilityKeys(tile) : this.getTileKeys(tile, property);
    // Business Feature: Don't show anything if location is not provided
    if (property === 'AttractionLocations' && isCriteriaEmpty) {
      return false;
    }
    if (isEmpty(tileKey) && isCriteriaEmpty) {
      return true;
    }
    if (isCriteriaEmpty) {
      return true;
    }
    // Check for 'ALL' selection
    if (isCriteriaArray ? find(criteria, item => this.checkCriteriaAll(item)) : this.checkCriteriaAll(criteria)) {
      return true;
    }
    return isCriteriaArray ? intersection(criteria, tileKey).length > 0 : includes(tileKey, criteria);
  }
  getAccessibilityKeys(tile) {
    const property = get(tile, `Content.Accessibility`, null);
    if (isEmpty(property)) {
      return null;
    }
    return isArray(property) ? map(property, 'Key') : get(property, 'Key');
  }
  checkCriteriaAll(criteria) {
    return !!criteria && (criteria === 'all' || criteria.startsWith('all_'));
  }
  static {
    this.ɵfac = function GdsPoiFilterService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsPoiFilterService)(i0.ɵɵinject(i1.GeolocationService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GdsPoiFilterService,
      factory: GdsPoiFilterService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsPoiFilterService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.GeolocationService
  }], null);
})();

/*
 * Public API Surface of gds-poi-filter
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GdsPoiFilterModule, GdsPoiFilterService };
